export function createPageUrl(pageName: string) {
    return '/' + pageName.replace(/ /g, '-');
}

export function getSafeBackUrl(url: string | null | undefined): string | null {
  let parentOrigin = '';

  // First priority: if the current page is already on completelawsupport.com, use the current origin.
  // This guarantees we stay on the same subdomain (www vs non-www) that the user is currently authenticated on.
  if (typeof window !== 'undefined' && window.location.hostname.includes('completelawsupport.com')) {
    parentOrigin = window.location.origin;
  }

  // 1. Try to get origin from document.referrer
  if (!parentOrigin) {
    try {
      if (typeof document !== 'undefined' && document.referrer) {
        const ref = document.referrer;
        if (ref.includes('completelawsupport.com')) {
          const parsed = new URL(ref);
          parentOrigin = parsed.origin;
        }
      }
    } catch (e) {
      console.error("Error reading document.referrer:", e);
    }
  }

  // 2. Fall back to origin from the back query parameter
  if (!parentOrigin && url && url.includes('completelawsupport.com')) {
    try {
      const parsed = new URL(url);
      parentOrigin = parsed.origin;
    } catch (e) {
      if (url.includes('www.completelawsupport.com')) {
        parentOrigin = 'https://www.completelawsupport.com';
      } else {
        parentOrigin = 'https://completelawsupport.com';
      }
    }
  }

  // If we couldn't find a completelawsupport origin, return the original url
  if (!parentOrigin) {
    return url || null;
  }

  // 3. Determine the correct portal path
  let portalPath = '/eas-portal/';
  const currentUrl = typeof window !== 'undefined' ? window.location.href.toLowerCase() : '';
  const backParamLower = url ? url.toLowerCase() : '';
  if (currentUrl.includes('vals') || backParamLower.includes('vals')) {
    portalPath = '/vals-portal/';
  } else if (currentUrl.includes('jbl') || backParamLower.includes('jbl')) {
    portalPath = '/jbl-portal/';
  } else if (currentUrl.includes('lacw') || backParamLower.includes('lacw')) {
    portalPath = '/lacw-portal/';
  } else if (currentUrl.includes('rga') || backParamLower.includes('rga') || currentUrl.includes('greensill') || backParamLower.includes('greensill')) {
    portalPath = '/rga-portal/';
  }

  return parentOrigin + portalPath;
}

export function redirectTopWindow(url: string) {
  // If running in a standalone tab/window (not in an iframe), try to close it first.
  // This returns the user to the original portal tab and preserves their session.
  if (window.self === window.top) {
    try {
      window.close();
    } catch (e) {
      console.warn("Could not close window, falling back to redirect:", e);
    }
  }

  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch {
    window.location.href = url;
  }
}